import serialize from "../../helpers/serialize"

export default {
  utmQs(state) {
    return serialize(state.utms)
  },
  invitationsCnt(state) {
    return Object.keys(state.sentInvitations).length
  },
  invitations(state) {
    return Object.values(state.sentInvitations)
  }
}
